<!--
 * @Author: qyy 826631402@qq.com
 * @Date: 2023-07-24 17:00:13
 * @LastEditors: qyy 826631402@qq.com
 * @LastEditTime: 2024-01-31 10:44:34
 * @FilePath: \esm_web\src\views\common\RdTop.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<!--header-->
    <div class="header">
      <div class="top clearfix">
        <div class="img" v-if="showImg === 1">
          <router-link to="/" tag="a" class="logo fl">
            <img src="/static/images/logo.png"/>
          </router-link>
        </div>
        <div class="img" v-if="showImg === 2">
          <router-link to="/" tag="a" class="logo fl">
            <img src="/static/images/hainanlogo.png"/>
          </router-link>
        </div>

            <div class="top-contact fr" v-if="showImg == 1">
                <div class="t-c-slide clearfix">
                    <img class="fl" src="/static/images/icon-phone.png" />
                    <p class="fl">咨询热线: <span>{{ profile.telephone }}</span></p>
                </div>
                <div class="t-c-slide clearfix">
                    <img class="fl" src="/static/images/icon-email.png" />
                    <p class="fl">邮箱: {{ profile.email }}</p>
                </div>
            </div>
        </div>

        <ul class="nav clearfix">
            <li :class="{ active: curMenu == 1 }"><router-link to="/index" tag="a">首&nbsp;&nbsp;页</router-link></li>
            <li :class="{ active: curMenu == 2 }"><router-link to="/stuintroduce" tag="a">中心简介</router-link></li>
            <li :class="{ active: curMenu == 3 }"><router-link to="/stunotice" tag="a">通知公告</router-link></li>
            <li :class="{ active: curMenu == 4 }"><router-link to="/stupolicy" tag="a">政策法规</router-link></li>
            <li :class="{ active: curMenu == 5 }"><router-link to="/sturecruit" tag="a">人才服务</router-link></li>
            <li :class="{ active: curMenu == 6 }"><router-link to="/stuoccupation" tag="a">职业工种</router-link></li>
            <li v-if="showImg == 2" :class="{ active: curMenu == 7 }"><router-link to="/stucompany" tag="a">合作同创</router-link></li>
            <li v-if="showImg == 1" :class="{ active: curMenu == 7 }"><a :href="'https://zxbm.scjxjypx.com/'" target="_blank">在线报名</a></li>
            <li :class="{ active: curMenu == 8 }"><router-link to="/stuachievement" tag="a">成绩查询</router-link></li>
            <li :class="{ active: curMenu == 9 }"><router-link to="/stucertificate" tag="a">证书查询</router-link></li>
        </ul>

    </div>
</template>
<style src="../../../static/css/studentindex.css" scoped></style>
<script>
export default {
    props:{
        profile:{//中心简介，包含邮箱联系方式等信息
            type:Object,
        },
    },
	data() {
    return {
      showImg: 1,
      curMenu: '',//当前选中路由
    };
	},
	methods: {
        //点击logo
		goIndex() {
			this.$router.push({ path: "/" });
		},
        //当前选中路由
		showMenuActive(route) {
			if (route.meta && route.meta.menuIndex) {
				this.curMenu = route.meta.menuIndex;
			}
		},
	},
	created() {
        //初始化时设置当前选中路由
        this.showMenuActive(this.$route);
	},
	mounted() {
    var domain = window.location.hostname
    // 1四川2海南
    if (domain == "hnjnrd.scjxjypx.com") {
      this.showImg = 2
    }
	},
	watch: {
		$route(to, from) {
			//监听路由是否变化
			this.showMenuActive(this.$route);
			// this.dialogVisible = false;
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/views/common/RdTop.vue